import * as React from 'react';

// @ts-ignore
import Badge from 'components/Badge';
import Button, { ButtonColor, ButtonSize } from 'components/Button';

type Props = {
  groupName: string;
  groupMembershipRequestsCount: number;
};

export default class PendingMembershipsButton extends React.Component<Props> {
  render() {
    const { groupName, groupMembershipRequestsCount } = this.props;

    const buttonColor =
      groupMembershipRequestsCount > 0 ? ButtonColor.brand : ButtonColor.polarBear;
    const badgeColor = groupMembershipRequestsCount > 0 ? 'white' : 'koala';

    return (
      <Button
        level="primary"
        color={buttonColor}
        size={ButtonSize.xsmall}
        to={`/classes/${groupName}/people/pending_memberships`}
        eventKey="request_to_join.people_list.request_to_join.click">
        Pending requests
        <Badge
          count={groupMembershipRequestsCount}
          color={badgeColor}
          size="large"
          shape="square"
        />
      </Button>
    );
  }
}
